import type { TemplateResult } from "lit";
import { html } from "lit";

export function renderEmailFooter(
  onEmailSubmit: (e: Event) => void
): TemplateResult {
  return html`
    <div class="email-footer">
      <section class="email-container">
        <div class="email-header">
          <svg
            width="24"
            height="24"
            fill="#ed6234"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 0a1 1 0 0 1 1 1v6.589l3.626 2.63.067.06a.963.963 0 0 1 .132.156l.073.125-.02-.039c.041.076.072.155.092.235l.023.126L24 11v12l-.002.067-.011.098-.025.111-.025.074-.059.129-.04.066-.071.097-.06.065-.083.075-.122.083-.096.05-.096.036-.134.034-.058.008L23 24H1a1 1 0 0 1-1-1V10.99l.007-.105.023-.128.037-.117.036-.081.033-.062.044-.069-.058.093.04-.068.082-.108.081-.083a.962.962 0 0 1 .102-.082L4 7.59V1a1 1 0 0 1 1-1h14zM2 12.684V22h17.08L4.683 14.149a.998.998 0 0 1-.313-.172L2 12.684zm20-.001l-2.37 1.294a.998.998 0 0 1-.313.172l-5.23 2.85L22 21.315v-8.632zM18 2H6v10.588l6 3.273 6-3.273V2zm-3 7a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h6zm0-4a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2h6z"
            />
          </svg>
          <h3 class="email-title">Stay in Touch</h3>
        </div>
        <form class="email-form" @submit=${onEmailSubmit}>
          <input
            type="email"
            name="email"
            class="email-input"
            placeholder="Enter your email address."
            aria-label="Email address"
            required
          />
          <button type="submit" class="email-button">Submit</button>
        </form>
      </section>
    </div>
  `;
}
